/**
 * BlogHeading Component Theme
 */

const BlogHeading = {
  parts: [
    'container',
    'articleContainer',
    'titleContainer',
    'title',
    'metadataShareContainer',
    'metadataContainer',
    'metadataRow',
    'metadataItem',
    'metadataLabel',
    'metadataValue',
    'metadataValueOnly',
    'metadataDivider',
    'shareContainer',
    'shareLabel',
    'shareDivider',
    'socialIcons',
    'socialIcon',
    'bottomDivider',
    'descriptionContainer',
    'description'
  ],

  baseStyle: {
    container: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: {base: 12, lg: 20},
      alignSelf: 'stretch',
      width: '100%',
      paddingTop: {base: '40px', lg: 12},
      paddingBottom: {base: '0', lg: 0},
    },

    articleContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: {base: 4, lg: 6},
      alignSelf: 'stretch',
    },

    titleContainer: {
      display: 'flex',
      maxWidth: {base: '100%', lg: '840px'},
      justifyContent: 'flex-start',
      alignItems: 'center',
    },

    title: {
      flex: '1 0 0',
      color: 'brandColors.greyscale90',
      fontFamily: 'aktiv-grotesk',
      fontSize: {base: '32px', lg: '60px'},
      fontWeight: '400',
      lineHeight: '120%',
      letterSpacing: {base: '-0.32px', lg: '-0.6px'},
    },

    metadataShareContainer: {
      display: 'flex',
      alignItems: {base: 'flex-start', lg: 'center'},
      gap: 6,
      alignSelf: 'stretch',
      flexDirection: {base: 'column', lg: 'row'},
    },

    metadataContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: {base: 6, md: 6},
      flex: '1 0 0',
      sx: {
        'hr': {
          display: 'none',
        },
      },
    },

    metadataRow: {
      display: 'flex',
      alignItems: 'center',
      gap: {base: 12, md: 6},
      rowGap: {base: 6, md: 'unset'},
      flexWrap: 'wrap',
    },

    metadataItem: {
      display: 'flex',
      flexDirection: {base: 'column', lg: 'row'},
      alignItems: {base: 'flex-start', lg: 'center'},
      gap: 2,
    },

    metadataLabel: {
      color: 'brandColors.primaryDarkLinen',
      fontFamily: 'aktiv-grotesk',
      fontSize: '2xs',
      fontWeight: '600',
      lineHeight: '120%',
      letterSpacing: '2px',
      textTransform: 'uppercase',
    },

    metadataValue: {
      color: 'brandColors.greyscale70',
      fontFamily: 'aktiv-grotesk',
      fontSize: 'xs',
      fontWeight: '600',
      lineHeight: '120%',
      letterSpacing: '2.4px',
      textTransform: 'uppercase',
    },

    metadataValueOnly: {
      color: 'brandColors.primaryDarkLinen',
      fontFamily: 'aktiv-grotesk',
      fontSize: 'xs',
      fontWeight: '600',
      lineHeight: '120%',
      letterSpacing: '2.4px',
      textTransform: 'uppercase',
    },

    metadataDivider: {
      width: 0.25,
      height: {base: 8.5, lg: 3.5},
      backgroundColor: 'brandColors.linen03',
      orientation: 'vertical',
    },

    shareContainer: {
      display: 'flex',
      alignItems: 'center',
      gap: 6,
      py: 4,
    },

    shareLabel: {
      color: 'brandColors.greyscale90',
      fontFamily: 'aktiv-grotesk',
      fontSize: 'sm',
      fontWeight: '500',
      lineHeight: '120%',
    },

    shareDivider: {
      width: 0.25,
      height: 6,
      alignSelf: 'stretch',
      backgroundColor: 'brandColors.linen03',
      orientation: 'vertical',
    },

    socialIcons: {
      display: 'flex',
      alignItems: 'center',
      gap: 6,
    },

    socialIcon: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: 5,
      height: 5,
      cursor: 'pointer',
      color: 'brandColors.greyscale90',
      _hover: {
        opacity: 0.7,
      },
      _focus: {
        outline: '2px solid',
        outlineColor: 'brandColors.primaryDarkLinen',
        outlineOffset: '2px',
      },
    },

    bottomDivider: {
      width: '100%',
      height: 0,
      borderTop: '1px solid',
      borderColor: 'brandColors.greyscale10',
    },

    descriptionContainer: {
      display: 'flex',
      justifyContent: {base: 'flex-start', lg: 'flex-end'},
      alignItems: 'center',
      gap: 2.5,
      alignSelf: 'stretch',
    },

    description: {
      maxWidth: {base: '100%', lg: '619px'},
      color: 'brandColors.greyscale90',
      fontSize: {base: 'md', lg: 'xl'},
      fontWeight: 'normal',
      lineHeight: {base: '160%', lg: '150%'},
      pt: {base: 0, lg: 0},
    },
  },
};

export default BlogHeading;
